"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingListBookingListToJSON = exports.BookingListBookingListFromJSONTyped = exports.BookingListBookingListFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BookingListBookingListFromJSON(json) {
    return BookingListBookingListFromJSONTyped(json, false);
}
exports.BookingListBookingListFromJSON = BookingListBookingListFromJSON;
function BookingListBookingListFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'date': !(0, runtime_1.exists)(json, 'date') ? undefined : json['date'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : (0, _1.AmountFromJSON)(json['amount']),
        'negative': !(0, runtime_1.exists)(json, 'negative') ? undefined : json['negative'],
        'additionalText': !(0, runtime_1.exists)(json, 'additionalText') ? undefined : json['additionalText'],
        'itemsId': !(0, runtime_1.exists)(json, 'itemsId') ? undefined : json['itemsId'],
        'invoiceId': !(0, runtime_1.exists)(json, 'invoiceId') ? undefined : json['invoiceId'],
        'unifiedInvoiceId': !(0, runtime_1.exists)(json, 'unifiedInvoiceId') ? undefined : json['unifiedInvoiceId'],
        'linkText': !(0, runtime_1.exists)(json, 'linkText') ? undefined : json['linkText'],
    };
}
exports.BookingListBookingListFromJSONTyped = BookingListBookingListFromJSONTyped;
function BookingListBookingListToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'date': value.date,
        'amount': (0, _1.AmountToJSON)(value.amount),
        'negative': value.negative,
        'additionalText': value.additionalText,
        'itemsId': value.itemsId,
        'invoiceId': value.invoiceId,
        'unifiedInvoiceId': value.unifiedInvoiceId,
        'linkText': value.linkText,
    };
}
exports.BookingListBookingListToJSON = BookingListBookingListToJSON;
//# sourceMappingURL=BookingListBookingList.js.map